import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import { TRAFFIC_TYPES } from '@/api/common';
import { useVendorVisitTrend } from '@/api/vendor';
import { usePageFilterContext } from '@/components/page';
import { NotesPanel } from '@/components/panels';
import VisitBreakdownTrendChart from '@/features/charts/VisitBreakdownTrendChart';
import { StackModeToggleButton } from '@/features/StackModeToggleButton';
import { ROUTES } from '@/router';

type Props = {
  vendorId?: string;
  isLoading?: boolean;
};

const VendorWeeklyVisitsChart = ({ vendorId, isLoading: isVendorLoading }: Props) => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();
  const [visitsMode, setVisitsMode] = useState<'stack' | 'percent'>('stack');

  const {
    vendorVisitTrend: data,
    isLoading: isVendorWeeklyVisitsLoading,
    error,
  } = useVendorVisitTrend(vendorId, startDate, endDate, audience?.id);

  const isLoading = isVendorLoading || isVendorWeeklyVisitsLoading;

  return (
    <NotesPanel
      startDate={startDate}
      endDate={endDate}
      title={<Trans>Total Visits</Trans>}
      noPadding
      style={{ height: 579 }}
      actions={
        <StackModeToggleButton
          mode={visitsMode}
          size="large"
          tooltipPlacement="topRight"
          onChange={setVisitsMode}
        />
      }
    >
      <VisitBreakdownTrendChart
        mode={visitsMode}
        data={data}
        isLoading={isLoading}
        error={error}
        tooltipRowLink={(item) => {
          const seriesId = item?.series?.userOptions?.id;
          if (seriesId === TRAFFIC_TYPES.TARGET) {
            return ROUTES.webTrafficActivityWithParams({
              'w.vendorIds': vendorId,
              'w.audienceIds': audience?.isTAM ? undefined : audience?.id,
              'w.inTam': audience?.isTAM ? 'true' : undefined,
              'w.metrics.visits': '[1,]',
            });
          } else if (seriesId === TRAFFIC_TYPES.OTHER) {
            return ROUTES.webTrafficActivityWithParams({
              'w.vendorIds': vendorId,
              'w.audienceIds!': audience?.isTAM ? undefined : audience?.id,
              'w.inTam': audience?.isTAM ? 'false' : undefined,
              'w.metrics.visits': '[1,]',
            });
          } else if (item?.key === 'total') {
            return ROUTES.webTrafficActivityWithParams({
              'w.vendorIds': vendorId,
              'w.metrics.visits': '[1,]',
            });
          }
        }}
      />
    </NotesPanel>
  );
};

export default VendorWeeklyVisitsChart;
